import { Swiper } from 'swiper';
import { Autoplay } from 'swiper/modules';

const totalDelay = 5000;

function initializeSwiper() {
  const swiper = new Swiper('.hero-banner__carousel', {
    speed: 300,
    spaceBetween: 0,
    slidesPerView: 1,
    modules: [Autoplay],
    autoplay: {
      delay: totalDelay,
      disableOnInteraction: false,
    },
  });

  return swiper;
}

function animateProgressBar(swiper: Swiper, timeLeft: number, percentage: number) {
  const index = swiper.realIndex;
  const bars: NodeListOf<HTMLElement> = document.querySelectorAll(
    `.hero-banner-section .pagination-button .bar-fill`,
  );
  const targetBars: NodeListOf<HTMLElement> = document.querySelectorAll(
    `.hero-banner-section .pagination-button.button-${index} .bar-fill`,
  );

  bars.forEach((bar) => {
    bar.style.width = `0%`;
  });
  targetBars.forEach((targetBar) => {
    targetBar.style.width = `${100 - percentage * 100}%`;
  });
}

function hydrateButtons(swiper: Swiper) {
  const slideCount = swiper.slides.length;
  for (let i = 0; i < slideCount; ++i) {
    const Buttons: NodeListOf<HTMLElement> = document.querySelectorAll(
      `.hero-banner-section .pagination-button.button-${i}`,
    );
    Buttons.forEach((button) => {
      button.addEventListener('click', () => {
        swiper.slideTo(i, 300);
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const swiper = initializeSwiper();
  swiper.on('autoplayTimeLeft', (swiper, timeLeft, percentage) => {
    animateProgressBar(swiper, timeLeft, percentage);
  });
  hydrateButtons(swiper);
});
